import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Divider,
  List,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch } from "../../hooks/useAppReducer";
import { fetchBlogBySlug, fetchLatestBlogs } from "../../redux/features";
import { useSelector } from "react-redux";
import { colors } from "../../styles/color";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { Helmet } from "react-helmet-async";

const BlogDetails = () => {
  const { blogDetail, latestBlogs } = useSelector(
    (state: any) => state.blogList
  );

  const navigate = useNavigate();
  const useStyles: any = makeStyles({
    conatiner: {
      maxWidth: "1280px !important",
      margin: "auto",
      padding: "0 24px 24px 20px",
    },
  });
  const classes = useStyles();
  const { slug } = useParams<{ slug: string }>();
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (slug) {
      dispatch(fetchBlogBySlug(slug));
      dispatch(fetchLatestBlogs(7));
    }
  }, [slug, dispatch]);

  const items = [
    "Introduction – Why Your Profile Matters",
    "Choose a Professional Display Picture",
    "Craft a Compelling Bio",
    "Showcase Your Best Content",
    "Link Multiple Accounts",
    "Pro Tips to Keep Your Profile Updated",
    "Conclusion",
  ];

  return (
    <>
      {blogDetail?.data?.title ===
        "What is Influencer Marketing and How Does it Work in 2025" && (
        <Helmet>
          <title>
            Influencer Marketing Guide 2025: What it is and how it work{" "}
          </title>
          <meta
            name="description"
            content=" Complete guide to influencer marketing 2025: definitions, strategies, benefits, and implementation tips."
          />

          {/* Canonical */}
          <link
            rel="canonical"
            href="https://quickfluence.com/blog/what-is-influencer-marketing-and-how-does-it-work-in-2025"
          />

          {/* Open Graph */}
          <meta
            property="og:title"
            content="Influencer Marketing Guide 2025: What it is and how it work"
          />
          <meta
            property="og:description"
            content=" Complete guide to influencer marketing 2025: definitions, strategies, benefits, and implementation tips."
          />
          <meta
            property="og:url"
            content=" https://quickfluence.com/blog/what-is-influencer-marketing-and-how-does-it-work-in-2025"
          />
          <meta property="og:site_name" content="quickfluence" />
          <meta property="og:type" content="article" />
          <meta property="og:locale" content="en" />
          <meta
            property="og:image:alt"
            content="Influencer marketing guide 2025.what it is and how works"
          />
          <meta
            property="og:image"
            content="https://backend.quickfluence.com/public/storage/image/blog/1764593692.png"
          />

          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          <meta name="robots" content="index, follow" />
        </Helmet>
      )}
      {blogDetail?.data?.title ===
        "How to Choose the Right Influencer Partnership in 2025" && (
        <Helmet>
          <title>How to Choose the Right Influencer Partnership in 2025 </title>
          <meta
            name="description"
            content="Influencer partnership models made simple to help brands choose the right fit. Compare sponsored posts, affiliate programs, and ambassadorship partnerships."
          />

          {/* Canonical */}
          <link
            rel="canonical"
            href="https://quickfluence.com/blog/how-to-choose-the-right-influencer-partnership-in-2025"
          />

          {/* Open Graph */}
          <meta
            property="og:title"
            content="How to Choose the Right Influencer Partnership in 2025"
          />
          <meta
            property="og:description"
            content="Influencer partnership models made simple to help brands choose the right fit. Compare sponsored posts, affiliate programs, and ambassadorship partnerships."
          />
          <meta
            property="og:url"
            content="https://quickfluence.com/blog/how-to-choose-the-right-influencer-partnership-in-2025"
          />
          <meta property="og:site_name" content="quickfluence" />
          <meta property="og:type" content="article" />
          <meta property="og:locale" content="en" />
          <meta
            property="og:image:alt"
            content="how to choose tigh influencer partnership in 2025"
          />
          <meta
            property="og:image"
            content="https://backend.quickfluence.com/public/storage/image/blog/1765269539.png"
          />

          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          <meta name="robots" content="index, follow" />
        </Helmet>
      )}
      <Box className={classes.conatiner}>
        <Box
          sx={{
            ".MuiButton-root svg path": {
              stroke: colors.basics.primary,
            },
            ".MuiButton-startIcon": {
              mr: "4px",
            },
            mt: "40px",
          }}
        >
          <Button
            variant="text"
            sx={{
              mt: { sm: "0", xs: "5px" },
              fontSize: "20px",
              lineHeight: "160%",
            }}
            startIcon={<KeyboardArrowLeftIcon />}
            onClick={() => navigate("/blog")}
          >
            Back to blogs
          </Button>
        </Box>
        <Grid container columnSpacing={2.5} mt={4}>
          {/* Left Side */}
          <Grid item xs={12} md={8}>
            <Box
              sx={{
                maxWidth: "800px",
              }}
            >
              <Box>
                <Typography
                  variant="h1"
                  fontSize="36px"
                  fontWeight={600}
                  lineHeight="44px"
                  mb={2}
                  textAlign="left"
                >
                  {blogDetail?.data?.title}
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: colors.dark[600],
                  color: colors.basics.primary,
                  p: "20px 20px",
                  borderRadius: "8px",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  sx={{
                    color: colors.basics.primary,
                  }}
                  variant="body1"
                  fontSize="14px"
                  fontWeight={500}
                  lineHeight="170%"
                  // mb={2}
                  textAlign="left"
                >
                  By {blogDetail?.data?.author_name}
                </Typography>
                <Typography
                  sx={{
                    color: colors.basics.primary,
                  }}
                  variant="body1"
                  fontSize="14px"
                  fontWeight={500}
                  lineHeight="170%"
                  // mb={2}
                  textAlign="left"
                >
                  {blogDetail?.data?.published_at}
                </Typography>
              </Box>
              <Box mt="32px">
                <img
                  src={blogDetail?.data?.featured_image}
                  style={{
                    width: "100%",
                    height: "420px",
                    borderRadius: "20px",
                  }}
                  alt="blog-img"
                />
              </Box>
              <Box>
                <Typography
                  variant="body1"
                  fontSize="20px"
                  fontWeight={400}
                  lineHeight="160%"
                  mb={2}
                  textAlign="left"
                  dangerouslySetInnerHTML={{
                    __html: blogDetail?.data?.content,
                  }}
                ></Typography>
              </Box>
            </Box>
          </Grid>

          {/* Right Side */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                borderRadius: "12px",
                p: 2,
                backgroundColor: "#1a1a1a",
                color: "#fff",
                boxShadow: "0px 4px 20px rgba(0,0,0,0.3)",
                maxWidth: "400px",
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  color: colors.basics.primary,
                  fontWeight: "500",
                  fontSize: "16px",
                  mb: "16px",
                }}
              >
                Latest Blogs
              </Typography>

              <List disablePadding>
                {/* {console.log("ajahdkjhajdskadhkhkas",latestBlogs?.data)} */}
                {latestBlogs?.data.map((item: any, index: any) => (
                  <React.Fragment key={index}>
                    <Typography
                      onClick={() => navigate(`/blog/${item.slug}`)}
                      variant="subtitle1"
                      sx={{
                        px: 0,
                        py: "12px",
                        fontSize: "16px",
                        "&:hover": {
                          color: colors.basics.primary,
                        },
                        fontWeight: "400",
                      }}
                    >
                      {item?.title}
                    </Typography>
                    {index < latestBlogs.data?.length - 1 && (
                      <Divider sx={{ borderColor: colors.dark[100] }} />
                    )}
                  </React.Fragment>
                ))}
              </List>
            </Box>
          </Grid>
        </Grid>
        <Divider sx={{ borderColor: colors.dark[100], mt: "60px" }} />
        <Box
          // component="span"
          sx={{
            fontSize: {
              xs: "20px",
              sm: "24px",
              md: "28px",
            },
            mt: "50px",

            display: "flex",
            justifyContent: "center",
            fontFamily: "Poppins",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: {
              xs: "32px",
              sm: "38px",
              md: "42px",
            },
            color: colors.basics.white,
            textAlign: "center",
          }}
        >
          Latest
          <Box
            component="span"
            sx={{
              fontSize: {
                xs: "20px",
                sm: "24px",
                md: "36px",
              },
              ml: "8px",
              color: colors.basics.primary,
            }}
          >
            Blogs
          </Box>
        </Box>
        <Box
          sx={{
            width: "100%",
            mt: "15px",
          }}
        >
          <Typography
            sx={{
              color: colors.gray[500],
              lineHeight: {
                xs: "28px",
                sm: "32px",
                md: "180%",
              },
              margin: "auto !important",
              display: "flex",
              justifyContent: "center",
              maxWidth: "600px",
              textAlign: "center",
              width: "100%",
              m: {
                xs: "12px 0 28px",
                sm: "16px 0 32px",
                md: "16px 0 40px",
              },
              fontSize: {
                md: "18px",
                xs: "14px",
              },
              fontWeight: 400,
            }}
            variant="body2"
          >
            Learn, grow, and get inspired with content crafted for creators and
            brands alike.
          </Typography>
        </Box>

        <Grid container spacing={3} sx={{ mt: "60px", mb: "100px" }}>
          {latestBlogs?.data?.map((post: any) => (
            <Grid item xs={12} sm={6} md={4} key={post.id}>
              <Card
                sx={{
                  p: "20px",
                  background: colors.dark[600],
                  color: "white",
                  borderRadius: "20px",
                  overflow: "hidden",
                  // height: "100%",
                }}
              >
                <CardMedia
                  component="img"
                  height="200"
                  image={post?.featured_image}
                  alt={post?.title}
                  sx={{
                    borderRadius: "20px",
                  }}
                />
                <CardContent
                  sx={{
                    px: 0,
                    pb: "0 !important",
                    ".MuiButtonBase-root": {
                      "&:hover": {
                        backgroundColor: "transparent",
                      },
                    },
                  }}
                >
                  {/* Title (2 lines max) */}
                  <Typography
                    variant="h6"
                    // component="div"
                    sx={{
                      fontWeight: "bold",
                      mb: 1,
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      lineHeight: {
                        xs: "28px",
                        sm: "32px",
                        md: "180%",
                      },
                      fontSize: {
                        xs: "14px",
                        md: "20px",
                      },
                    }}
                  >
                    {post?.title}
                  </Typography>

                  {/* Description (2 lines max) */}
                  <Typography
                    variant="body2"
                    sx={{
                      lineHeight: {
                        xs: "28px",
                        sm: "32px",
                        md: "180%",
                      },
                      fontSize: {
                        xs: "14px",
                      },
                      color: "gray",
                      mb: 2,
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {console.log("post :", post)}
                    {post?.excerpt}
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 2,
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        display: "block",
                        mb: 1,
                        color: colors.gray[300],
                        lineHeight: {
                          xs: "28px",
                          sm: "32px",
                          md: "180%",
                        },
                        fontSize: {
                          xs: "14px",
                        },
                        fontWeight: 400,
                      }}
                    >
                      By {post?.author_name}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        display: "block",
                        mb: 1,
                        color: colors.gray[300],
                        lineHeight: {
                          xs: "28px",
                          sm: "32px",
                          md: "180%",
                        },
                        fontSize: {
                          xs: "14px",
                        },
                        fontWeight: 400,
                      }}
                    >
                      {post.published_at}
                    </Typography>
                  </Box>
                  <Button
                    onClick={() => navigate(`/blog/${post.slug}`)}
                    variant="outlined"
                    sx={{
                      width: "100%",
                      borderColor: colors.dark[100],
                      background: "transparent",
                    }}
                  >
                    Read more
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default BlogDetails;
